import { render, staticRenderFns } from "./Top-Off-Plans.vue?vue&type=template&id=1b5bc47a&scoped=true"
import script from "./Top-Off-Plans.vue?vue&type=script&lang=js"
export * from "./Top-Off-Plans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5bc47a",
  null
  
)

export default component.exports